<template>
  <div
    class="scrollable only-y queue-reports-dashboard"
    v-loading="plotLoading"
  >
    <el-dialog
      class="queue-reports-modal"
      width="440px"
      :visible="modalVisible"
      :before-close="handleCloseModal"
      :close-on-click-modal="false"
    >
      <h2 class="form-section-header">Filter Settings</h2>

      <h3 class="black-text mb-5">Select Date Range</h3>
      <el-date-picker
        class="mb-10"
        style="margin-left: auto"
        v-model="historyDateRange"
        type="datetimerange"
        align="right"
        format="yyyy-MM-dd HH:mm"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="datePickerOptions"
      >
      </el-date-picker>

      <h3 class="black-text mb-10 mt-0">Select Distribution</h3>
      <el-radio-group v-model="distribution">
        <el-radio-button type="default" label="daily">Daily</el-radio-button>
        <el-radio-button label="monthly">Monthly</el-radio-button>
        <el-radio-button label="hourly">Hourly</el-radio-button>
      </el-radio-group>

      <el-form>
        <el-button class="mt-20" @click="doAdvanced"> Update </el-button>
      </el-form>
    </el-dialog>

    <div class="flex">
      <el-button class="mb-10" style="margin-left: auto" @click="doExport">
        Export Data
      </el-button>
    </div>

    <div
      class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
    >
      <div v-if="!noIvrs" class="flex">
        <div class="flex align-center">
          <dads-select
            v-model="selectedIVR"
            value-key="id"
            filterable
            style="margin-top: 0"
            class="queue-quick-drop"
            placholder="Select IVR"
            @change="ivrQuickLoad"
          >
            <el-option
              v-for="item in ivrOptions"
              :key="item.id"
              :value="item"
              :label="item.name"
            />
          </dads-select>
        </div>

        <el-radio-group
          v-model="presetSelection"
          @change="doPreset"
          class="ml-10 hidden-xs-only"
        >
          <el-radio-button type="default" label="last10"
            >Last 10 Days</el-radio-button
          >
          <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
        </el-radio-group>
        <el-checkbox
          class="mr-10"
          border
          v-model="normalize"
          :label="normalize ? 'Ratio' : 'Count'"
          style="margin-left: auto"
          @change="buildChart"
        />
        <el-tooltip placement="top">
          <template slot="content">
            {{ selectedDateRange }}
            <br />
            {{ distribution.toUpperCase() }}
          </template>
          <el-button @click="modalVisible = true" style="height: 40px">
            Filter
          </el-button>
        </el-tooltip>
        <el-button
          @click="resetPlot(false)"
          v-if="advancedActive"
          style="background-color: #f25a6b; color: #fff; height: 40px"
        >
          Reset
        </el-button>
      </div>
      <div v-else class="flex">
        <h2 class="mt-0">
          <v-svg sprite="receptionist" class="voxo-red"></v-svg>
          Selected Account Has No Virtual Receptionists
        </h2>
      </div>
      <div
        id="activity-plot"
        style="height: 385px; width: 100%"
        class="mt-10"
      ></div>
    </div>

    <el-row :gutter="30" v-if="!noIvrs">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20">
            <div class="stats-flex-body fadeInLeft">
              <div class="stat-header-flex flex widget-title">
                <h3 class="stat-header text-truncate">
                  <v-svg
                    width="18"
                    height="18"
                    class="voxo-dark-red"
                    sprite="refresh"
                  />
                  <span class="pl-10">LOOP RATIO</span>
                  <el-tooltip placement="top">
                    <template slot="content">
                      <p>
                        Measure of number of loops per unique <br />
                        entry to the virtual receptionist.
                      </p>
                    </template>
                    <i class="el-icon-question ml-10"></i>
                  </el-tooltip>
                </h3>
                <div
                  class="stat-switcher flex align-center"
                  style="margin-left: auto"
                ></div>
              </div>
              <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                {{ loopRatio }}
              </h1>
              <div class="stats-sub">
                <div class="sub-stat-group">
                  <div class="sub-stat-number text-left">
                    {{ totalEntries }}
                  </div>
                  <div class="sub-stat-title text-right">TOTAL ENTRIES</div>
                </div>
                <div class="sub-stat-group">
                  <div class="sub-stat-number text-right">
                    {{ uniqueEntries }}
                  </div>
                  <div class="sub-stat-title text-right">UNIQUE ENTRIES</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20">
            <div class="stats-flex-body fadeInLeft">
              <div class="stat-header-flex flex widget-title">
                <h3 class="stat-header text-truncate mt-0">
                  <v-svg
                    width="18"
                    height="18"
                    class="voxo-green"
                    sprite="keypad"
                  />
                  <span class="pl-10">VALID KEYS</span>
                </h3>
                <div
                  class="stat-switcher flex align-center"
                  style="margin-left: auto"
                >
                  <el-radio-group
                    size="mini"
                    v-model="radioValidKeys"
                    @change="calcValidKey"
                  >
                    <el-radio-button label="Total"></el-radio-button>
                    <el-radio-button label="Avg"></el-radio-button>
                    <el-radio-button label="%"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                {{ displayValidKey }}
              </h1>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="card-base card-shadow--medium mb-30 widget small-widget">
          <div class="widget-header ph-20">
            <div class="stats-flex-body fadeInLeft">
              <div class="stat-header-flex flex widget-title">
                <h3 class="stat-header text-truncate mt-0">
                  <v-svg
                    width="18"
                    height="18"
                    class="voxo-red"
                    sprite="keypad"
                  />
                  <span class="pl-10">WRONG KEYS</span>
                </h3>
                <div
                  class="stat-switcher flex align-center"
                  style="margin-left: auto"
                >
                  <el-radio-group
                    size="mini"
                    v-model="radioWrongKeys"
                    @change="calcWrongKey"
                  >
                    <el-radio-button label="Total"></el-radio-button>
                    <el-radio-button label="Avg"></el-radio-button>
                    <el-radio-button label="%"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                {{ displayWrongKey }}
              </h1>
              <div class="stats-sub">
                <div class="sub-stat-group">
                  <div class="sub-stat-number text-left">
                    {{ wrongKeyTotal - disaWrongTotal }}
                  </div>
                  <div class="sub-stat-title text-right">Keys</div>
                </div>
                <div class="sub-stat-group">
                  <div class="sub-stat-number text-right">
                    {{ disaWrongTotal }}
                  </div>
                  <div class="sub-stat-title text-right">Ext</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div
            class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
          >
            <div id="keyPressPie" style="height: 300px; width: 100%"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div
            class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
          >
            <div id="keyPressBar" style="height: 300px; width: 100%"></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div
            class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
          >
            <div id="wrongKeyPressBar" style="height: 300px; width: 100%"></div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div
            class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
          >
            <div id="wrongKeyPressPie" style="height: 300px; width: 100%"></div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row :gutter="20" class="mb-20">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <h2 class="mt-0">Extension Dialing</h2>
        <vxe-table
          border="none"
          show-overflow
          highlight-hover-row
          height="375"
          empty-text="No Data"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :data="disaTableData"
        >
          <vxe-table-column
            field="ext"
            title="Extension"
            sortable
          ></vxe-table-column>
          <vxe-table-column
            field="count"
            title="Count"
            sortable
          ></vxe-table-column>
          <vxe-table-column
            field="percent"
            title="%"
            sortable
            sort-type="number"
          ></vxe-table-column>
        </vxe-table>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <h2 class="mt-0" style="opacity: 0">Other Events</h2>
        <div
          class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30 mt-20"
        >
          <div class="flex justify-flex-end mb-20">
            <el-radio-group
              size="mini"
              v-model="radioOthersBar"
              @change="buildOthersBar"
            >
              <el-radio-button label="Total"></el-radio-button>
              <el-radio-button label="Avg"></el-radio-button>
              <el-radio-button label="%"></el-radio-button>
            </el-radio-group>
          </div>

          <div id="othersBar" style="height: 300px; width: 100%"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import moment from "moment-timezone";
import echarts from "echarts";
import DadsSelect from "@/components/select";
import { ExportToCsv } from "export-to-csv";

export default {
  name: "IVRActivity",
  props: {
    maxTicks: { default: 9 },
    ivrOptions: { required: true },
    colorsAll: {
      default: () => [
        "#33aaee",
        "#35be8b",
        "#f25a6b",
        "#c485db",
        "#f79ca6",
        "#4cc3d2",
        "#ff8f02",
        "#0F85FF",
      ],
    },
  },
  components: { DadsSelect },
  data() {
    return {
      radioValidKeys: "Total",
      radioWrongKeys: "Total",
      radioTimeout: "Total",
      radioHangup: "Total",
      radioDisa: "Total",
      radioOthersBar: "Total",
      loopRatio: null,
      weightFactor: 1,

      displayValidKey: null,
      displayWrongKey: null,

      validKeyTotal: 0,
      wrongKeyTotal: 0,
      totalEntries: 0,
      uniqueEntries: 0,
      disaDistribution: [],
      disaTableData: [],
      disaTotal: 0,
      timeoutTotal: 0,
      hangupTotal: 0,
      timeoutRatioTotal: 0,
      hangupRatioTotal: 0,
      disaRatioTotal: 0,
      disaWrongTotal: 0,
      dashboardData: null,

      modalVisible: false,
      primaryData: null,
      selectedIVR: null,
      ivrName: null,
      plotGroups: [],
      chart: null,
      noIvrs: false,
      presetSelection: "last10",
      plotLoading: false,
      advancedActive: false,
      dateStart: null,
      dateEnd: null,
      distribution: "daily",
      normalize: false,
      keyPressPie: null,
      keyPressBar: null,
      keyPressData: null,
      keyPressTableData: [],
      keyPressChartType: "pie",
      wrongKeyPressPie: null,
      wrongKeyPressBar: null,
      wrongKeyPressData: null,
      wrongKeyPressTableData: [],
      othersBar: null,
      historyDateRange: [moment(), moment()],
      datePickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "week").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "month").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(3, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 6 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(6, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last year",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(12, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    colorTheme() {
      return this.$store.state.layout.theme;
    },
    selectedDateRange() {
      if (this.dateEnd && this.dateStart) {
        const dateStart = moment(this.dateStart).format("M/D/YY HH:mm");
        const dateEnd = moment(this.dateEnd).format("M/D/YY HH:mm");
        return `${dateStart} - ${dateEnd}`;
      }
    },
  },
  watch: {
    ivrOptions() {
      this.resetPlot(true);
    },
  },
  methods: {
    async initData() {
      if (this.ivrOptions.length) {
        this.noIvrs = false;
        this.selectedIVR = this.ivrOptions[0];
        this.doPreset("last10");
        //this event is just to give this component load time before trigger builds on other tabs.
        setTimeout(() => {
          this.$emit("waveReady");
        }, 1500);
      } else {
        if (this.chart) {
          this.chart.dispose();
        }
        this.noIvrs = true;
      }
    },
    doPreset(val) {
      if (val === "last10") {
        this.dateEnd = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.dateStart = moment().subtract(9, "days").format("YYYY-MM-DD");
        this.presetSelection = "last10";
        this.updateDateRangePicker();
        this.queryStats();
      }

      if (val === "lastMonth") {
        this.dateEnd = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.dateStart = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.presetSelection = "lastMonth";
        this.updateDateRangePicker();
        this.queryStats();
      }
    },
    doAdvanced() {
      this.dateStart = moment(this.historyDateRange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.dateEnd = moment(this.historyDateRange[1]).format(
        "YYYY-MM-DD HH:mm"
      );

      //if hourly distribution make sure it passes 30 day limit
      let allowed = 1;
      if (this.distribution === "hourly") {
        allowed =
          moment(this.dateEnd).diff(
            moment(this.dateStart).add(1, "day"),
            "days"
          ) <= 30;
      }

      if (allowed) {
        this.queryStats();
        this.handleCloseModal();
        this.advancedActive = true;
      } else {
        this.$notify({
          type: "error",
          message: "Max of 30 days exceeded for hourly distribution",
          title: "Limit Exceeded",
        });
      }
    },
    ivrQuickLoad() {
      this.dateStart = moment(this.historyDateRange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.dateEnd = moment(this.historyDateRange[1]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.queryStats();
    },
    resetPlot(tenantChanged) {
      this.advancedActive = false;
      this.distribution = "daily";
      if (tenantChanged) {
        this.ivrName = null;
        this.initData();
      } else {
        this.doPreset("last10");
      }
    },
    updateDateRangePicker() {
      this.historyDateRange = [moment(this.dateStart), moment(this.dateEnd)];
    },
    handleCloseModal() {
      this.modalVisible = false;
    },
    convertTime(time) {
      if (time !== null) {
        const hours = Math.floor(time / 3600);
        const remainderSeconds = time % 3600;
        const minutes = Math.floor(remainderSeconds / 60);
        const seconds = Math.round(remainderSeconds % 60);

        if (hours > 0) {
          return hours + "hr " + minutes + "m";
        }
        if (minutes > 0) {
          return minutes + "m";
        }
        if (seconds > 0) {
          return seconds + "s";
        }
        return "0";
      }

      return "N/A";
    },
    buildX() {
      const dateKeys = Object.keys(this.primaryData);
      this.weightFactor = dateKeys.length;

      this.xInterval = 0;

      if (dateKeys.length > this.maxTicks) {
        this.xInterval = Math.ceil(dateKeys.length / this.maxTicks);
      }

      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      return {
        data:
          this.distribution === "hourly"
            ? dateKeys.map((item) => item.split("_")[1])
            : dateKeys,
        boundaryGap: dateKeys.length <= 10,
        axisLabel: {
          interval: this.xInterval,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: axisColor,
          },
        },
        axisTick: {
          interval: this.xInterval,
        },
      };
    },
    buildY1() {
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";
      return {
        name: "Count",
        position: "left",
        splitLine: { show: false },
        axisLine: {
          lineStyle: {
            color: axisColor,
          },
        },
      };
    },
    buildPrimary(xAxis) {
      this.primaryLegend = [];
      this.plotGroups = [
        "Total Entries",
        "Unique Entries",
        "Valid Key Presses",
        "Ext Dials",
        "Timeouts",
        "Hangups",
        "Wrong Key Presses",
      ];

      if (this.primaryData) {
        const callData = { ...this.primaryData };

        let dataGroups = {};
        for (let i = 0; i < this.plotGroups.length; i++) {
          dataGroups[this.plotGroups[i]] = [];
        }

        for (let day in callData) {
          if (callData.hasOwnProperty(day)) {
            dataGroups["Total Entries"].push(
              this.normalize
                ? callData[day].totalEntries > 0
                  ? 1
                  : 0
                : callData[day].totalEntries
            );
            dataGroups["Unique Entries"].push(
              this.normalize
                ? (
                    callData[day].uniqueEntries / callData[day].totalEntries
                  ).toFixed(2)
                : callData[day].uniqueEntries
            );
            dataGroups["Valid Key Presses"].push(
              this.normalize
                ? callData[day].validKeyRatioTotal
                : callData[day].validKeyTotal
            );
            dataGroups["Ext Dials"].push(
              this.normalize
                ? callData[day].disaRatioTotal
                : callData[day].disaTotal
            );
            dataGroups["Timeouts"].push(
              this.normalize
                ? callData[day].timeoutRatioTotal
                : callData[day].timeoutTotal
            );
            dataGroups["Hangups"].push(
              this.normalize
                ? callData[day].hangupRatioTotal
                : callData[day].hangupTotal
            );
            dataGroups["Wrong Key Presses"].push(
              this.normalize
                ? callData[day].wrongKeyRatioTotal
                : callData[day].wrongKeyTotal
            );
          }
        }

        let series = [];
        let count = 0;
        for (let group in dataGroups) {
          if (dataGroups.hasOwnProperty(group)) {
            series.push({
              name: `${group}`,
              type: xAxis.length > 13 ? "line" : "bar",
              symbol: "circle",
              smooth: true,
              showSymbol: true,
              yAxisIndex: 0,
              symbolRepeat: true,
              symbolSize: 3,
              symbolMargin: 1,
              barMaxWidth: 10,
              z: -10,
              lineStyle: {
                color: this.colorsAll[count],
              },
              itemStyle: {
                color: this.colorsAll[count],
                borderColor: this.colorsAll[count],
                borderWidth: 3,
              },
              data: dataGroups[group],
            });
            this.primaryLegend.push({ name: `${group}` });
            count++;
          }
        }
        return series;
      }

      return [];
    },
    buildChart() {
      if (this.chart) {
        this.chart.dispose();
      }

      this.chart = echarts.init(this.chartElement);

      const xAxis = this.buildX();
      const y1 = this.buildY1();

      const data1 = this.buildPrimary(xAxis.data);

      let y2 = null;
      let data2 = null;

      if (this.secondaryData) {
        y2 = this.buildY2();
        data2 = this.buildSecondary(xAxis.data);
      }

      const seriesData = data2 ? [...data1, ...data2] : data1;
      const yAxis = y2 ? [y1, y2] : [y1];

      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      this.chart.setOption({
        grid: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis,
        yAxis,
        series: seriesData,
        legend: {
          show: true,
          type: "scroll",
          orient: "horizontal",
          icon: "rectangle",
          itemWidth: 15,
          itemHeight: 3,
          data: this.primaryLegend,
          textStyle: {
            color: axisColor,
          },
        },
      });
    },
    buildKeyPressCharts() {
      const seriesData = [];
      let count = 0;
      for (let key in this.keyPressData) {
        if (this.keyPressData[key]) {
          seriesData.push({
            value: this.keyPressData[key],
            name: key,
            itemStyle: {
              color: this.colorsAll[count],
            },
          });
          count++;
        }
      }
      this.keyPressTableData = [...seriesData];

      this.buildKeypressPie();
      this.buildKeypressBar();
    },
    buildKeypressPie() {
      if (this.keyPressPie) {
        this.keyPressPie.dispose();
      }
      this.keyPressPie = echarts.init(this.keyPressPieElement);

      this.keyPressPie.setOption({
        title: {
          text: "Valid Key Presses",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: "middle",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        series: [
          {
            name: "Key Press Data",
            type: "pie",
            radius: "50%",
            lineStyle: {
              color: this.colorsAll[0],
            },
            data: this.keyPressTableData,
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      });
    },
    buildKeypressBar() {
      if (this.keyPressBar) {
        this.keyPressBar.dispose();
      }

      this.keyPressBar = echarts.init(this.keyPressBarElement);
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      this.keyPressBar.setOption({
        title: {
          text: "Valid Key Presses",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "vertical",
          right: "right",
          top: "top",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        yAxis: {
          type: "category",
          data: this.keyPressTableData.map((item) => item.name),
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        series: [
          {
            name: "Count",
            type: "bar",
            itemStyle: {
              color: this.colorsAll[1],
            },
            data: this.keyPressTableData.map((item) => +item.value),
          },
        ],
      });
    },
    buildWrongKeyPressCharts() {
      const seriesData = [];
      let count = 0;
      for (let key in this.wrongKeyPressData) {
        if (this.wrongKeyPressData[key]) {
          seriesData.push({
            value: this.wrongKeyPressData[key],
            name: key ? key : "No Key",
            itemStyle: {
              color: this.colorsAll[count],
            },
          });
          count++;
        }
      }
      this.wrongKeyPressTableData = [...seriesData];

      this.buildWrongKeyPressPie();
      this.buildWrongKeyPressBar();
    },
    buildWrongKeyPressPie() {
      if (this.wrongKeyPressPie) {
        this.wrongKeyPressPie.dispose();
      }
      this.wrongKeyPressPie = echarts.init(this.wrongKeyPressPieElement);

      this.wrongKeyPressPie.setOption({
        title: {
          text: "Wrong Key Presses",
          subtext: "Wrong Ext Dials Are Not Included",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: "middle",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        series: [
          {
            name: "Wrong Key Press Data",
            type: "pie",
            radius: "50%",
            data: this.wrongKeyPressTableData,
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      });
    },
    buildWrongKeyPressBar() {
      if (this.wrongKeyPressBar) {
        this.wrongKeyPressBar.dispose();
      }

      this.wrongKeyPressBar = echarts.init(this.wrongKeyPressBarElement);
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      this.wrongKeyPressBar.setOption({
        title: {
          text: "Wrong Key Presses",
          subtext: "Wrong Ext Dials Are Not Included",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "vertical",
          right: "right",
          top: "top",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        yAxis: {
          type: "category",
          data: this.wrongKeyPressTableData.map((item) => item.name),
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        series: [
          {
            name: "Count",
            type: "bar",
            data: this.wrongKeyPressTableData.map((item) => +item.value),
            itemStyle: {
              color: this.colorsAll[2],
            },
          },
        ],
      });
    },
    buildOthersBar() {
      if (this.othersBar) {
        this.othersBar.dispose();
      }

      this.othersBar = echarts.init(this.othersBarElement);
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      let seriesData = [];
      switch (this.radioOthersBar) {
        case "Total":
          seriesData = [this.disaTotal, this.timeoutTotal, this.hangupTotal];
          break;
        case "Avg":
          seriesData = [
            (this.disaTotal / this.weightFactor).toFixed(2),
            (this.timeoutTotal / this.weightFactor).toFixed(2),
            (this.hangupTotal / this.weightFactor).toFixed(2),
          ];
          break;
        case "%":
          seriesData = [
            this.disaRatioTotal,
            this.timeoutRatioTotal,
            this.hangupRatioTotal,
          ];
          break;
      }

      this.othersBar.setOption({
        title: {
          text: "Other Events",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "vertical",
          right: "right",
          top: "top",
          textStyle: {
            color: this.colorTheme === "theme-dark" ? "#c9d1d9" : "#2c2d30",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            this.radioOthersBar === "Avg"
              ? `Ext Dials / ${this.unitsMap()}`
              : "Ext Dials",
            this.radioOthersBar === "Avg"
              ? `Timeouts / ${this.unitsMap()}`
              : "Timeouts",
            this.radioOthersBar === "Avg"
              ? `Hangups / ${this.unitsMap()}`
              : "Hangups",
          ],
          boundaryGap: [0, 0.01],
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: axisColor,
            },
          },
        },
        series: [
          {
            name: "Value",
            type: "bar",
            data: seriesData,
            itemStyle: {
              color: this.colorsAll[0],
            },
          },
        ],
      });
    },
    queryStats() {
      this.plotLoading = true;
      feathersClient
        .service("account-statistics")
        .create({
          type: "ivrActivity",
          tenantId: this.selectedTenant.id,
          ivrId: this.selectedIVR.id,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          distribution: this.distribution,
          timezone: this.user.timezone,
        })
        .then((res) => {
          this.dashboardData = res;
          this.primaryData = { ...res.distributionData };
          this.keyPressData = { ...res.validKeyDistribution };
          this.wrongKeyPressData = { ...res.wrongKeyDistribution };
          this.ivrName = this.selectedIVR.name;
          this.loopRatio = res.loopRatio;
          this.validKeyTotal = res.validKeyTotal;
          this.uniqueEntries = res.uniqueEntries;
          this.totalEntries = res.totalEntries;
          this.wrongKeyTotal = res.wrongKeyTotal;
          this.disaTotal = res.disaTotal;
          this.disaDistribution = res.disaDistribution;
          this.timeoutTotal = res.timeoutTotal;
          this.hangupTotal = res.hangupTotal;
          this.disaRatioTotal = res.disaRatioTotal;
          this.hangupRatioTotal = res.hangupRatioTotal;
          this.timeoutRatioTotal = res.timeoutRatioTotal;
          this.disaWrongTotal = res.disaWrongTotal;
          this.buildChart();
          this.buildDisplayStats();
          this.buildKeyPressCharts();
          this.buildWrongKeyPressCharts();
          this.buildOthersBar();
          this.plotLoading = false;
        })
        .catch((e) => {
          console.log("Could Not Process Stats Request");
          console.log(e);
          this.plotLoading = false;
        });
    },
    unitsMap() {
      const valueMap = {
        hourly: "hr",
        daily: "day",
        monthly: "mo",
      };
      return valueMap[this.distribution];
    },

    buildDisplayStats() {
      this.calcValidKey(this.radioValidKeys);
      this.calcWrongKey(this.radioWrongKeys);

      let disaTableData = [];
      for (let key in this.disaDistribution) {
        if (this.disaDistribution[key]) {
          const percent =
            +(this.disaDistribution[key] / this.disaTotal).toFixed(2) * 100;

          disaTableData.push({
            ext: key,
            count: this.disaDistribution[key],
            percent: percent < 1 ? "< 1" : percent.toFixed(0),
          });
        }
      }
      this.disaTableData = [...disaTableData];
    },
    calcValidKey(val) {
      const valueMap = {
        Total: this.validKeyTotal,
        Avg: `${(this.validKeyTotal / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalEntries
          ? `${((this.validKeyTotal / this.totalEntries) * 100).toFixed(1)} %`
          : "N/A",
      };
      this.displayValidKey = valueMap[val];
    },
    calcWrongKey(val) {
      const valueMap = {
        Total: this.wrongKeyTotal,
        Avg: `${(this.wrongKeyTotal / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalEntries
          ? `${((this.wrongKeyTotal / this.totalEntries) * 100).toFixed(1)} %`
          : "N/A",
      };
      this.displayWrongKey = valueMap[val];
    },

    doExport() {
      if (this.dashboardData) {
        let csvData = [];

        //push in the rows that are just metrics
        csvData.push({
          name: "Virtual Receptionist",
          count: this.ivrName,
          percent: "",
        });
        csvData.push({
          name: "Start Date",
          count: this.dateStart,
          percent: "",
        });
        csvData.push({ name: "End Date", count: this.dateEnd, percent: "" });
        csvData.push({
          name: "Distribution",
          count: this.distribution,
          percent: "",
        });

        //totals and ratios
        csvData.push({
          name: "Total Entries",
          count: this.dashboardData.totalEntries,
          percent: "",
        });
        csvData.push({
          name: "Unique Entries",
          count: this.dashboardData.uniqueEntries,
          percent: "",
        });
        csvData.push({
          name: "Loop Ratio",
          count: this.dashboardData.loopRatio,
          percent: "",
        });
        csvData.push({
          name: "Valid Key Presses",
          count: this.dashboardData.validKeyTotal,
          percent: "",
        });
        csvData.push({
          name: "Wrong Key Presses",
          count: this.dashboardData.wrongKeyTotal,
          percent: "",
        });
        csvData.push({
          name: "Wrong Keys",
          count:
            this.dashboardData.wrongKeyTotal -
            this.dashboardData.disaWrongTotal,
          percent: "",
        });
        csvData.push({
          name: "Wrong Ext Dials",
          count: this.dashboardData.disaWrongTotal,
          percent: "",
        });
        csvData.push({
          name: "Ext Dials",
          count: this.dashboardData.disaTotal,
          percent: "",
        });
        csvData.push({
          name: "Timeouts",
          count: this.dashboardData.timeoutTotal,
          percent: "",
        });
        csvData.push({
          name: "Hangups",
          count: this.dashboardData.hangupTotal,
          percent: "",
        });
        csvData.push({ name: "STATS DISTRIBUTION", count: "", percent: "" });

        for (let key in this.primaryData) {
          csvData.push({ name: key, count: "", percent: "" });
          csvData.push({
            name: "Total Entries",
            count: this.primaryData[key].totalEntries,
            percent: "",
          });
          csvData.push({
            name: "Unique Entries",
            count: this.primaryData[key].uniqueEntries,
            percent: "",
          });
          csvData.push({
            name: "Loop Ratio",
            count: this.primaryData[key].loopRatio,
            percent: "",
          });
          csvData.push({
            name: "Valid Key Presses",
            count: this.primaryData[key].validKeyTotal,
            percent: "",
          });
          csvData.push({
            name: "Wrong Key Presses",
            count: this.primaryData[key].wrongKeyTotal,
            percent: "",
          });
          csvData.push({
            name: "Wrong Keys",
            count:
              this.primaryData[key].wrongKeyTotal -
              this.primaryData[key].disaWrongTotal,
            percent: "",
          });
          csvData.push({
            name: "Wrong Ext Dials",
            count: this.primaryData[key].disaWrongTotal,
            percent: "",
          });
          csvData.push({
            name: "Ext Dials",
            count: this.primaryData[key].disaTotal,
            percent: "",
          });
          csvData.push({
            name: "Timeouts",
            count: this.primaryData[key].timeoutTotal,
            percent: "",
          });
          csvData.push({
            name: "Hangups",
            count: this.primaryData[key].hangupTotal,
            percent: "",
          });
        }

        if (this.keyPressTableData.length) {
          csvData.push({
            name: "VALID KEY DISTRIBUTION",
            count: "",
            percent: "",
          });
          for (let i = 0; i < this.keyPressTableData.length; i++) {
            csvData.push({
              name: this.keyPressTableData[i].name,
              count: this.keyPressTableData[i].value,
              percent: "",
            });
          }
        }

        if (this.wrongKeyPressTableData.length) {
          csvData.push({
            name: "WRONG KEY DISTRIBUTION",
            count: "",
            percent: "",
          });
          for (let i = 0; i < this.wrongKeyPressTableData.length; i++) {
            csvData.push({
              name: this.wrongKeyPressTableData[i].name,
              count: this.wrongKeyPressTableData[i].value,
              percent: "",
            });
          }
        }

        if (this.disaTableData.length) {
          csvData.push({
            name: "EXTENSION DIALING DISTRIBUTION",
            count: "",
            percent: "",
          });
          csvData.push({ name: "", count: "Count", percent: "Percent" });
          for (let i = 0; i < this.disaTableData.length; i++) {
            csvData.push({
              name: this.disaTableData[i].ext,
              count: this.disaTableData[i].count,
              percent: this.disaTableData[i].percent,
            });
          }
        }

        const options = {
          filename: `ivr_${this.ivrName}`,
          showLabels: false,
          headers: ["", "", "", ""],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(csvData);
      }
    },
  },
  mounted() {
    this.chartElement = document.getElementById("activity-plot");
    this.keyPressPieElement = document.getElementById("keyPressPie");
    this.keyPressBarElement = document.getElementById("keyPressBar");
    this.wrongKeyPressPieElement = document.getElementById("wrongKeyPressPie");
    this.wrongKeyPressBarElement = document.getElementById("wrongKeyPressBar");
    this.othersBarElement = document.getElementById("othersBar");
  },
};
</script>

<style lang="scss" scoped>
.stat-number {
  font-size: 2.25em;
  margin-top: 10px;
}

.stat-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  margin: 0;
  min-height: 32px;
}

.stats-sub {
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  width: 100%;
  margin-top: auto;
  height: 45px;
}

.stats-flex-body {
  height: 200px;
  display: flex;
  flex-direction: column;
}

.stat-header-flex {
  padding: 20px 0 12px 0;
}

.sub-stat-number {
  font: {
    weight: bold;
  }
}

.sub-stat-title {
  font-size: 0.85em;
}
</style>
